import {
  Accordion,
  AccordionSummary,
  Typography,
  Box,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GrpSettingsTable from './GrpSettingsTable/GrpSettingsTable';
import usePlanStore from '../../../../../../../../../store/planStore';

export interface GrpSettingsAccordionProps {
  isExpanded: boolean;
}

export default function GrpSettingsAccordion({
  isExpanded = false,
}: GrpSettingsAccordionProps) {
  const { countryForms, selectedCountry } = usePlanStore();
  const grpTable = countryForms[selectedCountry!]?.offline?.tv?.grpTable ?? [];
  return (
    <Accordion
      sx={{
        '.MuiAccordionSummary-root': {
          borderTop: 'unset',
          borderBottom: 'unset',
          paddingLeft: '15px',
          borderRadius: '5px',
        },
      }}
      expanded={isExpanded}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          alignItems: 'center',
          height: '24px',
          background: 'white',
          '.MuiAccordionSummary-content': {
            height: 'unset',
            pl: 0,
          },
        }}
      >
        <Typography variant="body2" fontWeight={700} pl={1}>
          MY GRP SETTINGS
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ background: 'primary.contrastText', padding: 0 }}>
        {grpTable && <GrpSettingsTable />}
      </AccordionDetails>
    </Accordion>
  );
}
